export default "__VITE_ASSET__BjEW$400__"